import React, { useEffect, useState } from "react";
import { useHistory, useLocation, Link } from "react-router-dom";
import { Tooltip, Progress, FloatButton } from "antd";
import {
  FetchUsersByCompany,
  ProjectDropdown,
  TimeManagementDailySummary,
} from "../../redux/actions/action";
import {
  SINGLE_UPLOAD_TO_S3,
  MULTIPLE_UPLOAD_TO_S3,
} from "../../redux/constants/type";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import upArrow from "../../assets/icons/upArrow.png";
import deleteIcon from "../../assets/icons/DeleteIcon.svg";
import AppDatePicker from "../../components/Common/AppDatePicker";
import calendar from "../../assets/icons/calendar.svg";
import TimerScreenShots from "./TimerScreenShots.js";
import TimerProgressBar from "./TimerProgressBar.js";
// npm install react-ripples-hover
import Link2 from "react-ripples-hover";

const ShowTimerActivity = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const path = location.pathname;

  const companyId = window.localStorage.getItem("companyid");
  const userId = window.localStorage.getItem("userid");

  const FetchUsersByCompanyRes = useSelector(
    (state) => state.user.FetchUsersByCompany
  );
  const fetchProjectDropdown = useSelector(
    (state) => state.user.fetchProjectDropdown
  );

  const timeManagementDailySummaryRes = useSelector(
    (state) => state.user.timeManagementDailySummaryRes
  );

  const [calendarIsOpen, setCalendarIsOpen] = useState(false);
  const [calendarIsOpen2, setCalendarIsOpen2] = useState(false);
  const [headerDate, setHeaderDate] = useState(new Date());
  const [summaryDate, setSummaryDate] = useState(new Date());
  const [allScreenShotsToggle, setAllScreenShotsToggle] = useState(false);

  const [userData, setUserData] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  const [selectedUserID, setSelectedUserID] = useState("");
  const [userDataOpen, setUserDataOpen] = useState(false);

  const [projectData, setProjectData] = useState([]);
  const [selectedProject, setSelectedProject] = useState("");
  const [selectedProjectID, setSelectedProjectID] = useState("");
  const [projectDataOpen, setProjectDataOpen] = useState(false);

  const [timeZoneData, setTimeZoneData] = useState([
    {
      name: "time1",
    },
    {
      name: "time2",
    },
    {
      name: "time3",
    },
  ]);
  const [selectedtimeZone, setSelectedtimeZone] = useState("");
  const [timeZoneDataOpen, setTimeZoneDataOpen] = useState(false);

  const [dailyTotal, setDailyTotal] = useState("");
  const [todaysActivity, setTodaysActivity] = useState("");
  const [weeklyActivity, setWeeklyActivity] = useState("");
  const [workedThisWeek, setWorkedThisWeek] = useState("");

  useEffect(() => {
    dispatch(FetchUsersByCompany(companyId, 0, 0));
    dispatch(ProjectDropdown());
    dispatch(
      TimeManagementDailySummary(
        userId,
        moment(summaryDate).format("YYYY-MM-DD")
      )
    );
  }, []);

  useEffect(() => {
    if (FetchUsersByCompanyRes?.data?.status === true) {
      setUserData(FetchUsersByCompanyRes?.data?.data);
    }
  }, [FetchUsersByCompanyRes]);

  useEffect(() => {
    if (fetchProjectDropdown?.status === true) {
      setProjectData(fetchProjectDropdown?.data);
    }
  }, [fetchProjectDropdown]);

  useEffect(() => {
    if (timeManagementDailySummaryRes) {
      setDailyTotal(timeManagementDailySummaryRes.totalTime);
      setTodaysActivity(timeManagementDailySummaryRes.todaysActivity);
      setWeeklyActivity(timeManagementDailySummaryRes.todaysActivity);
      setWorkedThisWeek(timeManagementDailySummaryRes.todaysActivity);
    }
  }, [timeManagementDailySummaryRes]);

  // Handler functions
  const handlePrev = () => {
    setHeaderDate((prev) => moment(prev).subtract(1, "day").toDate());
  };

  const handleNext = () => {
    setHeaderDate((prev) => moment(prev).add(1, "day").toDate());
  };

  const handleToday = () => {
    setHeaderDate(new Date());
  };

  return (
    <div className="p-4">
      <div className="d-flex justify-content-between align-items-end flex-wrap">
        <div className="d-flex gap-2 flex-wrap align-items-center">
          <Tooltip title="Prev date" color={""}>
            <Link2 className="p-0" rippleOnClick duration={1}>
              <div className="arrowsDiv pointer" onClick={handlePrev}>
                <img src={upArrow} alt="" className="arrows" />
              </div>
            </Link2>
          </Tooltip>

          <Tooltip title="Next date" color={""}>
            <Link2 className="p-0" rippleOnClick duration={1}>
              <div className="arrowsDiv pointer" onClick={handleNext}>
                <img src={upArrow} alt="" className="arrows2" />
              </div>
            </Link2>
          </Tooltip>

          <div
            className="flexContainer gap-1 arrowsDiv p-2"
            id="CalendarCssTimer"
          >
            <AppDatePicker
              open={calendarIsOpen}
              selected={headerDate}
              onChange={(val) => {
                setHeaderDate(val);
                setCalendarIsOpen(false);
              }}
              onSelect={(d, event) => {
                event.preventDefault();
              }}
              dateFormat="dd/MM/yyyy"
            />

            <img
              className="calendarIcon pointer"
              onClick={() => setCalendarIsOpen((p) => !p)}
              src={calendar}
              alt=""
            />
          </div>

          <Link2 className="p-0" rippleOnClick duration={""}>
            <div className="arrowsDiv pointer" onClick={handleToday}>
              <p className="mb-0 allNotes">Today</p>
            </div>
          </Link2>

          <div className="arrowsDiv pointer d-none">
            <p className="mb-0 allNotes">All notes</p>
          </div>
        </div>

        <div className="d-flex gap-2 flex-wrap align-items-center pt-3 pt-xl-1">
          <div className="userDataDiv" style={{ position: "relative" }}>
            <p className="mb-1 ps-2">USER</p>
            <p
              className="mb-1 pointer arrowsDiv"
              style={{
                fontSize: "14px",
                fontWeight: "700",
                color: "black",
                opacity: "65%",
              }}
              onClick={() => {
                setUserDataOpen(!userDataOpen);
              }}
            >
              {selectedUser || "select user"}
            </p>

            {userDataOpen && (
              <div
                className="userDataSelectBox"
                style={{ position: "absolute" }}
              >
                <div className="userDataOptionDiv">
                  {userData.map((user, userIndex) => {
                    return (
                      <div
                        className={
                          selectedUserID === user.userid
                            ? "selectedData"
                            : "userDataOption"
                        }
                        onClick={() => {
                          setSelectedUser(user.firstname);
                          setSelectedUserID(user.userid);
                          setTimeout(() => {
                            setUserDataOpen(false);
                          }, 300);
                        }}
                      >
                        <p className="mb-1">{user.firstname}</p>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>

          <div className="userDataDiv" style={{ position: "relative" }}>
            <p className="mb-1 ps-2">PROJECT</p>
            <p
              className="mb-1 pointer arrowsDiv"
              style={{
                fontSize: "14px",
                fontWeight: "700",
                color: "black",
                opacity: "65%",
              }}
              onClick={() => {
                setProjectDataOpen(!projectDataOpen);
              }}
            >
              {selectedProject || "select project"}
            </p>

            {projectDataOpen && (
              <div
                className="userDataSelectBox"
                style={{ position: "absolute" }}
              >
                <div className="userDataOptionDiv">
                  {projectData.map((project, projectIndex) => {
                    return (
                      <div
                        className={
                          selectedProjectID === project.projectid
                            ? "selectedData"
                            : "userDataOption"
                        }
                        onClick={() => {
                          setSelectedProject(project.projectname);
                          setSelectedProjectID(project.projectid);
                          setTimeout(() => {
                            setProjectDataOpen(false);
                          }, 300);
                        }}
                      >
                        <p className="mb-1">{project.projectname}</p>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>

          <div className="userDataDiv d-none" style={{ position: "relative" }}>
            <p className="mb-1 ps-2">TIMEZONE</p>
            <p
              className="mb-1 pointer arrowsDiv"
              style={{
                fontSize: "14px",
                fontWeight: "700",
                color: "black",
                opacity: "65%",
              }}
              onClick={() => {
                setTimeZoneDataOpen(!timeZoneDataOpen);
              }}
            >
              {selectedtimeZone || "select timezone"}
            </p>

            {timeZoneDataOpen && (
              <div
                className="userDataSelectBox"
                style={{ position: "absolute" }}
              >
                <div className="userDataOptionDiv">
                  {timeZoneData.map((time, timeIndex) => {
                    return (
                      <div
                        className={
                          selectedtimeZone === time.name
                            ? "selectedData"
                            : "userDataOption"
                        }
                        onClick={() => {
                          setSelectedtimeZone(time.name);
                          setTimeZoneDataOpen(false);
                        }}
                      >
                        <p className="mb-1">{time.name}</p>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>

          <div className="d-flex gap-2 headerToggle mt-3">
            <p
              className={
                !allScreenShotsToggle
                  ? "selectedToggle mb-0"
                  : "optionToggle mb-0"
              }
              onClick={() => {
                setAllScreenShotsToggle(false);
              }}
            >
              Every 10 min
            </p>
            <p
              className={
                allScreenShotsToggle
                  ? "selectedToggle mb-0"
                  : "optionToggle mb-0"
              }
              onClick={() => {
                setAllScreenShotsToggle(true);
              }}
            >
              All screenshots
            </p>
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-between flex-wrap gap-3 pt-4">
        <div>
          <p className="mb-0 dailyTotal">
            Daily total:&nbsp; <span className="totalTime">{dailyTotal}</span>
          </p>
        </div>

        <div>
          <div className="d-flex flex-wrap gap-">
            <div className="weeklyDiv">
              <p className="mb-0 weeklyActivity">WEEKLY ACTIVITY</p>
              <p className="mb-0 dailyTotalPerc">{weeklyActivity || "76%"}</p>
            </div>

            <div className="weeklyDiv">
              <p className="mb-0 weeklyActivity">TODAY's ACTIVITY</p>
              <p className="mb-0 dailyTotalPerc">{todaysActivity || "76%"}</p>
            </div>

            <div className="weeklyDiv">
              <p className="mb-0 weeklyActivity">WORKED THIS WEEK</p>
              <p className="mb-0 dailyTotalPerc">
                {workedThisWeek || "131:42:11"}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div>
        <TimerScreenShots />
        {/* <TimerProgressBar /> */}
      </div>
    </div>
  );
};

export default ShowTimerActivity;
